import initializeInboxRulesEditState from './helpers/initializeInboxRulesEditState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('resetInboxRuleEdit')(function resetInboxRuleEdit(state) {
    var optionState = state.optionState;
    optionState.inboxRulesEditState = initializeInboxRulesEditState();
}));
//# sourceMappingURL=resetInboxRuleEdit.js.map